import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest, HttpResponse, HttpInterceptor, HttpHandler, HTTP_INTERCEPTORS } from '@angular/common/http';

import { Observable, throwError,of } from 'rxjs';
import { tap } from 'rxjs/operators';


import { CacheRequestService} from '../services/cache-request.service';
import { AppConfig } from 'src/app/configs/app.config';


@Injectable()
export class CachingInterceptor implements HttpInterceptor {
    logoutUrl:string = AppConfig.BASE_API_URL + "/auth/logout/";

    constructor(private cache:CacheRequestService ) {}
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const cachedResponse = this.cache.get(req);

        if( req.url === this.logoutUrl) {
            this.cache.reset();
        } else if(req.method === 'POST' ) {
            this.cache.delete(req.url);
            return next.handle(req);
        } else if(req.method === 'PUT' || req.method === 'DELETE') {
            this.cache.deleteRoot(req.url);
            return next.handle(req);
        }
        return cachedResponse ? of(cachedResponse) : this.sendRequest(req, next, this.cache);
    }

    sendRequest(
        req: HttpRequest<any>,
        next: HttpHandler,
        cache: CacheRequestService): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    cache.put(req, event);
                }
            })
        );
    }
}

export const CacheInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: CachingInterceptor,
    multi: true
};
